import 'devextreme/dist/css/dx.common.css'
import './themes/generated/theme.base.css'
import './themes/generated/theme.additional.css'
import './styles/theme.scss'

import Vue from 'vue'
import VueCookies from 'vue-cookies'
import BootstrapVue from 'bootstrap-vue'
import VueTimeago from 'vue-timeago'

import { config } from './config'
import App from './app'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(BootstrapVue)
Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: config.locale,
})

Vue.filter('date', (value) => {
  if (!value) {
    return ''
  }
  return new Date(value).toLocaleString(config.locale)
})
Vue.filter('percentage', (number) => {
  if (!number) {
    return ''
  }
  return number.toLocaleString(config.locale, {
    style: 'percent',
    minimumFractionDigits: 1,
  })
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
